import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  padding: 24px 48px;
  display: flex;
  flex-direction: column;
  gap: 28px;

  header {
    width: 100%;
    display: flex;
    flex-direction: row !important;
    align-items: center;
    justify-content: space-between;
  }

  main {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
  }
`

export const Title = styled.h4`
  font-weight: 900;
  font-size: 24px;
  line-height: 34px;
  color: #937251;
`

export const Table = styled.table`
  table-layout: fixed;
  width: 60%;

  th {
    font-weight: 900;
    font-size: 14px;
    line-height: 19px;
    color: #7B7C82;
    text-align: left;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #353744;
  }

  td, th {
    white-space: nowrap;
  }
`